import "./footer.css"

function Footer() {
  return (
        <div className="footer">
            <span>Online Market</span>
            <span>© freelanceinTH Dev.</span>
        </div>
    )
}

export default Footer